import { StyledQuestionReadyActions } from "./index.styled";
import storyIcon from "../../../assets/icons/story.png";
import artIcon from "../../../assets/icons/art.png";
import { Mic, Video } from "lucide-react";

interface QuestionReadyActionsProps {
  onExport?: () => void;
  onChooseBackground?: () => void;
  onVideoAnswer?: () => void;
  onVoiceAnswer?: () => void;
  isLoading?: boolean;
}

const QuestionReadyActions = ({
  onExport,
  onChooseBackground,
  onVideoAnswer,
  onVoiceAnswer,
  isLoading = false,
}: QuestionReadyActionsProps) => {
  return (
    <StyledQuestionReadyActions>
      <button
        type="button"
        className="action-button export-button"
        onClick={onExport}
        disabled={isLoading}
      >
        <img
          src={storyIcon}
          alt=""
          aria-hidden="true"
          className={`button-icon ${isLoading ? "loading" : ""}`}
        />
        {isLoading ? "מוריד..." : "הורדה"}
      </button>
      <button
        type="button"
        className="action-button background-button"
        onClick={onChooseBackground}
        disabled={isLoading}
      >
        <img src={artIcon} alt="" aria-hidden="true" className="button-icon" />
        בחירת רקע
      </button>
      {onVoiceAnswer && (
        <button
          type="button"
          className="action-button voice-button"
          onClick={onVoiceAnswer}
          disabled={isLoading}
        >
          <Mic size={12} strokeWidth={2.5} aria-hidden="true" />
          הקלטת קול
        </button>
      )}
      {onVideoAnswer && (
        <button
          type="button"
          className="action-button video-button"
          onClick={onVideoAnswer}
          disabled={isLoading}
        >
          <Video size={12} strokeWidth={2.5} aria-hidden="true" />
          סלפי וידאו
        </button>
      )}
    </StyledQuestionReadyActions>
  );
};

export default QuestionReadyActions;
